import I18n from 'I18n';
import { isEqual } from 'underscore';
import { getIsRtlLang } from 'forms-utils-lib/language/getIsRtlLang';
import { translate } from 'forms-utils-lib/language/translate';
import { getReverseLangDirectionThankYouMessage } from 'FormsUI/utils/LangDirectionUtils';
export const getThankYouMessageByLocale = locale => translate(I18n, 'defaultForm.thankYouMessage', {
  locale
});
const getTranslatedDefaultThankYouMessage = ({
  inlineMessage,
  newLocale,
  oldLocale
}) => {
  const defaultInlineMessage = getThankYouMessageByLocale(oldLocale);
  const newInlineMessage = getThankYouMessageByLocale(newLocale);
  const formatedDefaultInlineMessage = getIsRtlLang(oldLocale) ? getReverseLangDirectionThankYouMessage(defaultInlineMessage) : defaultInlineMessage;
  const isDefaultInlineMessage = isEqual(inlineMessage, formatedDefaultInlineMessage);
  if (isDefaultInlineMessage) {
    return getIsRtlLang(newLocale) ? getReverseLangDirectionThankYouMessage(newInlineMessage) : newInlineMessage;
  } else {
    return null;
  }
};
export default getTranslatedDefaultThankYouMessage;